import React, { useState, useRef, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useTranslation } from "../../utils/hooks/translateHook";
import { useLanguage } from "../../context/LanguageContext";
import LanguageSelector from "../../components/Navigation/LanguageSelector";
import MobileNavigation from "../../components/Navigation/MobileNavigation";
import { ReactComponent as CircleIcon } from "../../images/icons/CircleIcon.svg";
import { ReactComponent as ArrowIcon } from "../../images/icons/UpArrow.svg";
import { ReactComponent as LogoutIcon } from "../../images/icons/LogoutIcon.svg";
import { ReactComponent as HomeIcon } from "../../images/icons/HomeIcon.svg";
import Logo from "../../images/logoGlobal.png";
import "../../components/Navigation/Navigation.css";

function AdminNavigation({ currentUser, onSignOut }) {
  const navigate = useNavigate();
  const t = useTranslation();
  const { language } = useLanguage();
  const [showSignout, setShowSignout] = useState(false);
  const signoutRef = useRef(null);
  const [showCoursesMenu, setShowCoursesMenu] = useState(false);
   const coursesMenuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (signoutRef.current && !signoutRef.current.contains(e.target)) {
        setShowSignout(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <nav className={`navigation lang-${language}`}>
      <div className="nav-left">
        <MobileNavigation
          t={t}
          menuItems={[
            { label: "Dashboard", to: "/admin/dashboard" },
            { label: "Manage Users", to: "/admin/users" },
            { label: "Manage Content", to: "/admin/content" }
          ]}
        />
        <div><img className="navigation__logo" src={Logo} alt="Logo" onClick={() => navigate("/admin/dashboard")}/></div>
      </div>

      <ul className="navigation__menu">
        <li><NavLink to="/admin/">Dashboard</NavLink></li>
        <li><NavLink to="/admin/users">Manage Users</NavLink></li>
        <li className="nav-item-dropdown">
          <button
            className="nav-dropdown-trigger"
            onClick={() => setShowCoursesMenu(!showCoursesMenu)}
          >
            Manage Content
            <ArrowIcon
              className={`nav-dropdown-arrow ${showCoursesMenu ? "open" : ""}`}
            />
          </button>

          {showCoursesMenu && (
            <ul className="nav-submenu-admin courses">
              <li>
                <NavLink to="/admin/content/fundamentals" className="submenu-link">
                  Trading Fundamentals
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/content/html" className="submenu-link">
                  HTML Course
                </NavLink>
              </li>
            </ul>
          )}
        </li>
      </ul>

      <div className="navigation__actions">
        <div className="nav-icons">
          <button className="icon-button" onClick={() => navigate("/mycourses")}>
            <HomeIcon className="nav-icon" />
          </button>
          <div className="icon-with-arrow">
            <button className="user-avatar"
              onClick={() => setShowSignout(prev => !prev)}>
              <span className="avatar-circle">
                <CircleIcon className="nav-icon" />
                <span className="avatar-letter">
                  {currentUser?.name?.slice(0,1).toUpperCase() || "A"}
                </span>
              </span>
            </button>
            <ArrowIcon className={`nav-dropdown-arrow ${showSignout ? "open" : ""}`} />
            {showSignout && (
              <div className="nav-submenu-admin userinfo" ref={signoutRef}>
                <p className="userinfo-row">
                  <LogoutIcon className="userinfo-icon" />
                  <span onClick={onSignOut}>{t("logout")}</span>
                </p>
              </div>
            )}
          </div>

          <LanguageSelector />

        </div>
      </div>
    </nav>
  );
}

export default AdminNavigation;
